
import React from 'react';
import UserAvatar from 'views/user/UserAvatar';

import Slider from "react-slick";
import {Title} from 'views/AppElements';

import {A} from 'views/AppElements';
import AppUtil from 'AppUtil';

const SLIDER_SETTINGS = {
    autoplay: false,
    speed: 350,
    infinite: false,
    arrows: false,
    cssEase: 'cubic-bezier(0.97, 0.99, 0.98, 0.97)',
    className: 'artistSlider',
    variableWidth: true,
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 2,
    swipeToSlide: true,
    swipe: true,
    responsive: [
                {
                    breakpoint: 1198,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      swipeToSlide: true
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      swipeToSlide: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      swipeToSlide: true,
                      arrows: true
                    }
                }
    ]
  };


const AllArtistAvatar = () => {
  const user = {id: "allArtistAvatar", username: "All Artist"};

  const link = "/artist/all";
  return <div className="artistAvatar" id="allArtistPreview">
        <A href={link} style={{textDecoration: 'none'}}><UserAvatar user={user} /></A>

      <A href={link} className="artistName">View All</A>
    </div>
};

export const ArtistAvatar = ({user}) => {
    const userLink = user? AppUtil.getDesignerURL(user): "#";
    const username = user? user.username: "";
    return <div className="artistAvatar">
                <A href={userLink} style={{textDecoration: 'none'}}><UserAvatar user={user} /></A>

                <A href={userLink} className="artistName">{username}</A>
            </div>;
}

const ArtistSlider = (props) => {
    const users = props.users;

    let avatars = null;
    if(!users) {
      avatars = [1,2,3,4,5,6,7,8,9,10].map(i => <ArtistAvatar user={null} key={"SliderArtistLoader_"+i} />);
    } else {
      avatars = users.map(u => <ArtistAvatar user={u} key={"SliderArtist"+u.username+"_"+u.id} />).toArray();
      avatars.push(<AllArtistAvatar key="allArtist" />);
    }
      

    
    return <div id="artistSlider">
            <Title title={"ACTIVE ARTISTS"} />
            <Slider {...SLIDER_SETTINGS}>
                {avatars}
            </Slider>
        </div>
};

export default ArtistSlider;



// WEBPACK FOOTER //
// ./src/views/designer/ArtistSlider.js